import { render, staticRenderFns } from "./wuPromotionSection.vue?vue&type=template&id=65b7d841&"
import script from "./wuPromotionSection.vue?vue&type=script&lang=js&"
export * from "./wuPromotionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports